import React from "react";
import { StyleProp, ViewStyle, StyleSheet, View } from "react-native";
import { FontWeight, Text, TextSize } from "@timhortons/common/src/components/atoms/text";
import "./pdfRender.scss";
interface IProps {
  url: string;
  containerStyles: StyleProp<ViewStyle>;
  pdfStyles: any;
  onError?: (error: object) => void;
}

export default function PdfRenderer(props: IProps) {
  const { url, containerStyles, pdfStyles = { height: 400, width: 500 } } = props;
  return (
    <View style={[styles.container, containerStyles]}>
      {url && url.length > 0 ? (
        <embed
          className="embedClassName"
          type="application/pdf"
          src={url + "#toolbar=0"}
          style={pdfStyles}
        ></embed>
      ) : (
        <Text testId="pdf-notfound" textSize={TextSize.Regular} fontWeight={FontWeight.Bold}>
          Pdf Url Not found
        </Text>
      )}
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center"
  }
});
